import { GeckoBinnedDataBuffer } from 'features/dataLayers/geckoBinnedDataBuffer'
import { GeckoComponentDataFrame, GeckoComponentRect } from 'types'

import { useCdfDataGenerator } from './useCdfDataGenerator'

/**
 * A hook that returns a callback function that can be used to get the data for
 * a given entry (any object with `id` and `generation` fields).
 *
 *
 * @returns     A function with two parameters: `cdf: GeckoComponentDataFrame`, and `cropSelection: GeckoComponentRect`, where `cdf` is
 *              the cdf to fetch data for and `cropSelection` is an optional x/y filter.  The function returns data for the given `cdf` with the `cropSelection` filter applied.
 *              (as a `Promise<ReadonlyArray<number>>`) or `undefined` if it couldn't be fetched
 *
 *
 */
export function useCdfDataFetcher(): (
  entry: GeckoComponentDataFrame,
  cropSelection?: GeckoComponentRect
) => Promise<GeckoBinnedDataBuffer | undefined> {
  return useCdfDataGenerator()
}
